import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import clientSignupReducer from '../features/client/clientSignupSlice';
import clientUnsubscribeReducer from '../features/client/clientUnsubscribeSlice';
import candidateSignupReducer from '../features/candidate/candidateSignupSlice';
import candidateUnsubscribeReducer from '../features/candidate/candidateUnsubscribeSlice';
import currentCandidatePipelineReducer from '../features/client/currentCandidatePipelineSlice';

export const store = configureStore({
  reducer: {
    clientSignup: clientSignupReducer,
    clientUnsubscribe: clientUnsubscribeReducer,
    currentCandidatePipeline: currentCandidatePipelineReducer,
    candidateSignup: candidateSignupReducer,
    candidateUnsubscribe: candidateUnsubscribeReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
